<!--
xhrボタンコンポーネント
- AJAX通信中はラベルを「通信中」にする
- AJAX通信中はボタンを disabled にする
-->
<template>
    <button @click="onClick"
            :id="gtmEventId"
            :disabled="isDisabled"
            :type="buttonType">
        {{ buttonText }}
    </button>
</template>

<script>
export default {
    name: 'XhrButton',
    props: {
        invalid: {
            type: Boolean,
            default: false
        },
        isXhr: {
            type: Boolean,
            default: false
        },
        isError: {
            type: Boolean,
            default: false
        },
        buttonLabel: {
            type: String,
            default: '次へ'
        },
        buttonType: {
            type: String,
            default: 'button'
        },
        gtmEventId: {
            type: String,
            default: ''
        },
        activateJleagueId: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        buttonText: function(){
            return this.isXhr? '通信中': this.buttonLabel;
        },
        isDisabled: function(){
            return this.invalid || this.isXhr || this.isError || this.activateJleagueId;
        }
    },
    methods: {
        onClick: function(){
            if (this.isDisabled) {
                return;
            }
            this.$emit('on-click');
        }
    }
}
</script>
